module.exports = __webpack_public_path__ + "img/neil.5d9cdec3.png";